"use client";

import { useGSAP } from "@/lib/motion/gsap";
import { bindJumpMenu } from "@/lib/motion/jump-menu";
import { useMotionBag } from "@/components/site/motion/MotionContext";
import { JumpArrowIcon } from "@/components/icons/SiteMarks";
import { useContent } from "@/components/site/ContentProvider";

export function JumpMenu() {
  const site = useContent();
  const { motion, epoch } = useMotionBag();
  useGSAP(
    () => {
      if (!epoch) return;
      return bindJumpMenu(motion);
    },
    { dependencies: [epoch] },
  );
  return (
    <div className="jump_menu_wrap" style={{ visibility: "hidden" }} role="navigation" aria-label={site.aria.jumpMenu}>
      <div className="jump_menu_set jump_aspect">
        <div className="jump_menu_list jump_aspect f f-c">
          {site.jumpMenu.map((item) => (
            <div
              className="jump_menu_item jump_link jump_aspect f a-c"
              data-section={item.section}
              key={item.section}
            >
              <JumpArrowIcon />
              <strong className="label">{item.label}</strong>
            </div>
          ))}
        </div>
        <div className="jump_menu_line jump_aspect f a-e" aria-hidden="true">
          <i></i>
        </div>
        <div className="jump_menu_arrow jump_aspect f a-c j-e" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" width="6" height="14" fill="none" viewBox="0 0 6 14">
            <path stroke="currentColor" strokeLinecap="square" d="m.666 8.75 2.333 2.333L5.333 8.75M.666 5.25l2.333-2.333L5.333 5.25" />
          </svg>
        </div>
      </div>
    </div>
  );
}
